// eslint-disable-next-line
export default {
  id: 'pao_fit',
  type: 'savoury',
  title: 'Pão fit',
  ingredients: [
    '250g de trigo',
    '450g de iogurte grego 0% gordura',
    '20g de baking powder (fermento)',
    'Sal',
  ],
  parts: [
    {
      title: 'Base',
      methodOfPreparation: [
        'Mistura tudo bem muito com um pouco de sal',
        'Vai ficar bem molhado',
        'Coloca na mesa trigo',
        'Pega uma porção (uma bolinha)',
        'Passa trigo até formar uma camada que não gruda mais',
      ],
    },
    {
      title: 'Versão de frigideira',
      methodOfPreparation: [
        'Passa o rolo para ficar fina a massa',
        'Assa na frigideira até ficar dourado dos dois lados ou no forno até ficar dourado',
      ],
    },
    {
      title: 'Versão forno',
      methodOfPreparation: [
        'Passa gema de ovo em cima',
        'Coloca no forno por 30 minutos em 180 graus',
      ],
    },
  ],
};
